import { render } from "./건강_질병정보_type02.vue?vue&type=template&id=38a50fef"
import script from "./건강_질병정보_type02.vue?vue&type=script&lang=js"
export * from "./건강_질병정보_type02.vue?vue&type=script&lang=js"

import "./건강_질병정보_type02.vue?vue&type=style&index=0&id=38a50fef&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__